import React, { useState, useEffect, useContext } from "react";
import Spinner from "../Spinner/Spinner";
import "./Partners.css";
import { LanguageContext } from "../../context/LanguageContext";

import infographDE from "../../assets/images/infografika-de.png";
import infographFR from "../../assets/images/infografika-fr.png";

const Partners = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    if (language === "german") {
      fetch("https://swissmailsecurity.ch/wp-json/wp/v2/posts?categories=5")
        .then((res) => res.json())
        .then((res) => {
          setData(res);
          setIsLoading(false);
        });
    } else if (language === "french") {
      fetch("https://swissmailsecurity.ch/wp-json/wp/v2/posts?categories=9")
        .then((res) => res.json())
        .then((res) => {
          setData(res);
          setIsLoading(false);
        });
    }
  }, [language]);

  return (
    <>
      <div className="partners_container">
        <div className="partners_inner_container">
          <div className="partner_title_container">
            <span>
              {language === "german"
                ? "Drei Partner - eine gemeinsame"
                : "Trois partenaires – une plate-forme"}
            </span>
            <h3>
              {language === "german"
                ? "Secure-E-Mail-Plattform"
                : "de messagerie sécurisée commune"}
            </h3>
          </div>
          {isLoading ? (
            <div className="partners_content_loading">
              <Spinner />
            </div>
          ) : (
            <div className="partners_content_container">
              {data.map((item, index) => {
                return (
                  <div
                    className="partner_container"
                    key={index}
                    dangerouslySetInnerHTML={{ __html: item.content.rendered }}
                  ></div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="partner_infograph_container">
        {language === 'german'
          ? <img src={infographDE} width="100%" height="100%" alt="Infographimg" />
          : <img src={infographFR} width="100%" height="100%" alt="Infographimg" />
        }
        
      </div>
    </>
  );
};

export default Partners;
